<div class="top-tools-tab-mobile" id="tabs-tools" role="tablist">
    <a [routerLink]="['/grammar-checker']" role="tab" aria-selected="false" class="active" tabindex="-1" id="tab-grammar">
        <img src="../../../../assets/images/menu-icons/grammar-checker.svg" alt="文法 チェック">
        <p>文法チェッカー</p>
    </a>
    <a [routerLink]="['/paraphrasing-tool']" role="tab" aria-selected="false" tabindex="-1" id="tab-paraphraser">
        <img src="../../../../assets/images/menu-icons/pharaphraser.svg" alt="言い換える">
        <p>パラフレーズツール</p>
    </a>
    <a [routerLink]="['/ai-content-detector']" role="tab" aria-selected="false" tabindex="-1" id="tab-ai-detector">
        <img src="../../../../assets/images/menu-icons/ai-detector.svg" alt="AI検出器">
        <p>AI生成コンテンツ検出ツール</p>
    </a>
</div>

<!--Tool Design-->
<section class="banner-section">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-8">
                <div class="banner-title">
                    <div class="title">
                        <h1>無料オンライン文法チェッカー
                        </h1>
                        <!-- <h1>オンライン無料文章校正ツール</h1> -->
                        <!-- <span>Beta</span> -->
                    </div>
                    <!-- <p>TrinkaのAI搭載無料文章校正ツールは、日本語の文章を瞬時に自動校正。正確な日本語を、効率的・効果的に書くためのアシスタントツールとしてご活用いただけます。</p> -->
                    <p>AI搭載の無料文法チェッカーが、リアルタイムで英文チェックの結果を表示。単純な文法ミスやスペルミスの修正だけでなく、文章を総合的に校正します。<br/> 英語とスペイン語の文章チェックが可能です。
                    </p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="multiTabSection">
                    <ul class="nav nav-tabs" role="tablist">
                        <li class="nav-item" role="presentation">
                            <a class="nav-link active" data-toggle="tab" href="#EnglishGrammarChecker" role="tab" aria-label="english">English</a>
                        </li>
                        <li class="nav-item" role="presentation">
                            <a class="nav-link" data-toggle="tab" href="#SpanishGrammarChecker" role="tab" aria-label="spanish">Spanish</a>
                        </li>
                        <!-- <li class="nav-item" role="presentation">
                            <a class="nav-link" data-toggle="tab" href="#GermanGrammarChecker" role="tab" aria-label="german">German</a>
                        </li> -->
                    </ul><!-- Tab panes -->
                    <div class="tab-content">
                        <div class="tab-pane active" id="EnglishGrammarChecker" role="tabpanel">
                            <app-english-grammar-checker></app-english-grammar-checker>
                        </div>
                        <div class="tab-pane" id="SpanishGrammarChecker" role="tabpanel">
                            <app-spanish-grammar-checker></app-spanish-grammar-checker>
                        </div>
                        <!-- <div class="tab-pane" id="GermanGrammarChecker" role="tabpanel">
                            <app-german-grammar-checker></app-german-grammar-checker>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <span class="shape-1"></span>
    <span class="shape-2"></span>
    <span class="shape-3"></span>
</section>

<div class="trinka-banner section-pd-sm" id="real-time">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-8">
                <div class="trinka-title text-center">
                    <h3 class="text-white">お使いのブラウザで、リアルタイムの文法チェックを無料で</h3>
                </div>
                <div class="btn-group justify-content-center">
                    <a  id="GCChromeButton" href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" class="white-btn" target="_blank"><img src="../../../assets/images/NewChromeIcon.svg" alt="chrome - 文法チェッカー">Chromeにインストール</a>
                    <a  id="GCFirFoxButton" href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai-firefox-browser/" class="white-btn" target="_blank"><img src="../../../assets/images/NewFirefoxIcon.svg" alt="firefox - 文法チェッカー"> Firefox にインストール</a>
                    <a  id="GCEdgeButton" href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" class="white-btn" target="_blank"><img src="../../../assets/images/EdgeWhite_BGAndOutline.svg" alt="edge - 文法チェッカー"> Edge にインストール</a>
                </div>
            </div>
        </div>  
    </div>
</div>

<section class="section-pd list-wrapper-style-2">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-lg-12 col-md-12">
                <div class="trinka-title text-center mb-0">
                    <h2>文法やスペルミスのチェックにとどまらない<br class="d-lg-block d-none"/>一歩先の文法チェッカー</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>高度な文法チェックでライティングを洗練。<br/>
                        卓越した文章を実現します。</p>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-lg-12 col-md-12">
                <div class="row justify-content-center">
                    <div class="col-md-6 col-lg-4">
                        <div class="list-wrapper-content-2 list-style-cards bt-none">
                            <svg width="40" height="40" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.5 4.60547L1.95117 12H0.410156L3.62109 3.46875H4.60547L4.5 4.60547ZM6.63281 12L4.07812 4.60547L3.9668 3.46875H4.95703L8.17969 12H6.63281ZM6.50977 8.83594V10.002H1.86914V8.83594H6.50977ZM12.334 8.14453H10.1602L10.1484 7.07227H12.0469C12.3672 7.07227 12.6387 7.02539 12.8613 6.93164C13.0879 6.83398 13.2598 6.69531 13.377 6.51562C13.4941 6.33203 13.5527 6.11133 13.5527 5.85352C13.5527 5.56836 13.498 5.33594 13.3887 5.15625C13.2793 4.97656 13.1113 4.8457 12.8848 4.76367C12.6621 4.68164 12.377 4.64062 12.0293 4.64062H10.6055V12H9.13477V3.46875H12.0293C12.498 3.46875 12.916 3.51367 13.2832 3.60352C13.6543 3.69336 13.9688 3.83398 14.2266 4.02539C14.4883 4.21289 14.6855 4.45117 14.8184 4.74023C14.9551 5.0293 15.0234 5.37305 15.0234 5.77148C15.0234 6.12305 14.9395 6.44531 14.7715 6.73828C14.6035 7.02734 14.3555 7.26367 14.0273 7.44727C13.6992 7.63086 13.291 7.74023 12.8027 7.77539L12.334 8.14453ZM12.2695 12H9.69727L10.3594 10.834H12.2695C12.6016 10.834 12.8789 10.7793 13.1016 10.6699C13.3242 10.5566 13.4902 10.4023 13.5996 10.207C13.7129 10.0078 13.7695 9.77539 13.7695 9.50977C13.7695 9.23242 13.7207 8.99219 13.623 8.78906C13.5254 8.58203 13.3711 8.42383 13.1602 8.31445C12.9492 8.20117 12.6738 8.14453 12.334 8.14453H10.6816L10.6934 7.07227H12.8438L13.1777 7.47656C13.6465 7.49219 14.0312 7.5957 14.332 7.78711C14.6367 7.97852 14.8633 8.22656 15.0117 8.53125C15.1602 8.83594 15.2344 9.16406 15.2344 9.51562C15.2344 10.0586 15.1152 10.5137 14.877 10.8809C14.6426 11.248 14.3047 11.5273 13.8633 11.7188C13.4219 11.9062 12.8906 12 12.2695 12ZM21.7559 9.22266H23.2207C23.1738 9.78125 23.0176 10.2793 22.752 10.7168C22.4863 11.1504 22.1133 11.4922 21.6328 11.7422C21.1523 11.9922 20.5684 12.1172 19.8809 12.1172C19.3535 12.1172 18.8789 12.0234 18.457 11.8359C18.0352 11.6445 17.6738 11.375 17.373 11.0273C17.0723 10.6758 16.8418 10.252 16.6816 9.75586C16.5254 9.25977 16.4473 8.70508 16.4473 8.0918V7.38281C16.4473 6.76953 16.5273 6.21484 16.6875 5.71875C16.8516 5.22266 17.0859 4.79883 17.3906 4.44727C17.6953 4.0918 18.0605 3.82031 18.4863 3.63281C18.916 3.44531 19.3984 3.35156 19.9336 3.35156C20.6133 3.35156 21.1875 3.47656 21.6562 3.72656C22.125 3.97656 22.4883 4.32227 22.7461 4.76367C23.0078 5.20508 23.168 5.71094 23.2266 6.28125H21.7617C21.7227 5.91406 21.6367 5.59961 21.5039 5.33789C21.375 5.07617 21.1836 4.87695 20.9297 4.74023C20.6758 4.59961 20.3438 4.5293 19.9336 4.5293C19.5977 4.5293 19.3047 4.5918 19.0547 4.7168C18.8047 4.8418 18.5957 5.02539 18.4277 5.26758C18.2598 5.50977 18.1328 5.80859 18.0469 6.16406C17.9648 6.51562 17.9238 6.91797 17.9238 7.37109V8.0918C17.9238 8.52148 17.9609 8.91211 18.0352 9.26367C18.1133 9.61133 18.2305 9.91016 18.3867 10.1602C18.5469 10.4102 18.75 10.6035 18.9961 10.7402C19.2422 10.877 19.5371 10.9453 19.8809 10.9453C20.2988 10.9453 20.6367 10.8789 20.8945 10.7461C21.1562 10.6133 21.3535 10.4199 21.4863 10.166C21.623 9.9082 21.7129 9.59375 21.7559 9.22266Z" fill="#7A28A0"/>
                                <path d="M10.4004 18.5844L13.0658 21.5996L18.8004 15.5996" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <h3>複雑な文法</h3>
                            <p>複雑な文法ミスを修正し、文章を明瞭にします。</p>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-4">
                        <div class="list-wrapper-content-2 list-style-cards">
                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 25" fill="none">
                                <path d="M12 5H3" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M12 10H3" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M21 15H3" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M21 20H3" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <h3>文の構造</h3>
                            <p>誤解のない分かりやすい文構造に修正します。</p>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-4">
                        <div class="list-wrapper-content-2 list-style-cards">
                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 25" fill="none">
                                <path d="M15 14.25H7C6.59 14.25 6.25 13.91 6.25 13.5C6.25 13.09 6.59 12.75 7 12.75H15C15.41 12.75 15.75 13.09 15.75 13.5C15.75 13.91 15.41 14.25 15 14.25Z" fill="#7A28A0"/>
                                <path d="M16.029 10.5803H7.0882C6.62998 10.5803 6.25 10.2403 6.25 9.83032C6.25 9.42032 6.62998 9.08032 7.0882 9.08032H16.029C16.4872 9.08032 16.8672 9.42032 16.8672 9.83032C16.8672 10.2403 16.4872 10.5803 16.029 10.5803Z" fill="#7A28A0"/>
                                <path d="M12 18.25H7C6.59 18.25 6.25 17.91 6.25 17.5C6.25 17.09 6.59 16.75 7 16.75H12C12.41 16.75 12.75 17.09 12.75 17.5C12.75 17.91 12.41 18.25 12 18.25Z" fill="#7A28A0"/>
                                <path d="M15 23.25H9C3.38 23.25 2.25 20.6 2.25 16.32V10.15C2.25 5.41 3.85 3.48 7.96 3.25H16C16.01 3.25 16.03 3.25 16.04 3.25C20.15 3.48 21.75 5.41 21.75 10.15V16.32C21.75 20.6 20.62 23.25 15 23.25ZM8 4.75C5.2 4.91 3.75 5.79 3.75 10.15V16.32C3.75 20.15 4.48 21.75 9 21.75H15C19.52 21.75 20.25 20.15 20.25 16.32V10.15C20.25 5.8 18.81 4.91 15.98 4.75H8Z" fill="#7A28A0"/>
                            </svg>
                            <h3>単語の選択</h3>
                            <p>文脈に即した適切な単語を提案します。</p>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-4">
                        <div class="list-wrapper-content-2 list-style-cards bt-1">
                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 25" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M19.928 1.27032C19.3169 1.47798 17.1419 2.21843 15.0947 2.91565L11.3725 4.18343L7.23548 2.71954L3.09837 1.25554L3.06881 4.09998L3.03915 6.94443L1.76137 7.38887L0.483592 7.83332L0.455147 16.031C0.428592 23.6418 0.499864 24.2778 0.499864 24.2778C0.499864 24.2778 3.11648 23.6045 6.4207 22.5075L12.0391 20.6423L17.3169 22.3242C20.2197 23.2493 22.8071 24.0768 23.0669 24.163L23.5391 24.3199V16.2308V8.14176L22.4836 7.82465L21.428 7.50754V4.33154C21.428 1.28265 21.428 0.722229 21.428 0.722229C21.428 0.722229 20.5391 1.06265 19.928 1.27032ZM20.8888 4.44445C20.8888 6.59167 20.8888 7.33334 20.8888 7.33334C20.8888 7.33334 12.4043 4.65354 12.295 4.56376C12.2106 4.4942 20.8888 1.50001 20.8888 1.50001C20.8888 1.50001 20.8888 1.8889 20.8888 4.44445ZM11.5391 12.4908V20.2036L6.3447 21.9352C3.4877 22.8875 1.05542 23.6667 1.05542 23.6667C1.05542 23.6667 0.983592 20.1958 0.983592 15.9536V8.24076L6.12248 6.51798C8.94893 5.57054 11.3239 4.79132 11.4003 4.78654C11.5101 4.77954 11.5391 6.38976 11.5391 12.4908Z" fill="#7A28A0"/>
                                <path d="M5.60512 11.9638C5.8266 11.9016 6.04846 11.839 6.27068 11.7761C6.28327 12.9168 6.29586 14.0583 6.30846 15.2005C6.3129 15.565 6.24401 15.9072 6.09957 16.2261C5.95623 16.5427 5.7529 16.8161 5.48846 17.045C5.22512 17.2727 4.91401 17.4316 4.55734 17.5238C4.20179 17.615 3.88957 17.615 3.6229 17.525C3.35734 17.4338 3.15068 17.2694 3.00401 17.0316C2.85734 16.7927 2.78401 16.4938 2.7829 16.135C2.78142 15.0098 2.77957 13.885 2.77734 12.7605C2.99883 12.6983 3.22031 12.6361 3.44179 12.5738C3.44623 13.6812 3.44994 14.7879 3.4529 15.8938C3.4529 16.1261 3.49734 16.3227 3.58623 16.4794C3.67734 16.6372 3.80401 16.7461 3.96845 16.8083C4.1329 16.8672 4.32734 16.8694 4.55179 16.8105C4.77846 16.7527 4.9729 16.6494 5.13512 16.505C5.29957 16.3561 5.42401 16.1805 5.50957 15.975C5.59623 15.7705 5.63845 15.5494 5.63623 15.315C5.62586 14.1979 5.61549 13.0809 5.60512 11.9638Z" fill="#7A28A0"/>
                                <path d="M6.87845 16.8416C6.85623 15.1024 6.83401 13.3631 6.81179 11.6238C7.03253 11.5616 7.25327 11.499 7.47401 11.4361C7.48586 12.2694 7.49808 13.1024 7.51068 13.935C7.52846 13.9298 7.5466 13.925 7.56512 13.9205C8.16883 12.9175 8.77105 11.9112 9.37179 10.9016C9.65031 10.8231 9.92882 10.745 10.2073 10.6672C9.63105 11.6242 9.05327 12.5787 8.47401 13.5305C9.09031 14.3364 9.70846 15.145 10.3285 15.9561C10.0588 16.0257 9.78883 16.0953 9.51846 16.165C9.02512 15.5057 8.53253 14.8479 8.04068 14.1916C7.86957 14.4753 7.69845 14.7587 7.52734 15.0416C7.53475 15.5846 7.54253 16.1272 7.55068 16.6694C7.32623 16.7272 7.10216 16.7846 6.87845 16.8416Z" fill="#7A28A0"/>
                                <path d="M16.4898 11.4536C16.7205 11.515 16.9511 11.5768 17.1817 11.639C17.1878 12.7796 17.194 13.9206 17.2001 15.0619C17.2011 15.4253 17.1285 15.729 16.978 15.9708C16.8286 16.2106 16.6168 16.3761 16.3445 16.4651C16.0713 16.5541 15.7509 16.5509 15.3825 16.4556C15.0161 16.3604 14.6948 16.1981 14.4205 15.9666C14.1472 15.7342 13.9344 15.4578 13.7829 15.1373C13.6325 14.8159 13.5567 14.4714 13.5567 14.1059C13.5561 12.9597 13.5554 11.8135 13.5547 10.6672C13.7839 10.7287 14.0135 10.7901 14.2434 10.8515C14.2448 11.9761 14.2462 13.1 14.2475 14.2232C14.2486 14.4599 14.2936 14.6818 14.3847 14.8892C14.4788 15.0965 14.6088 15.2756 14.7787 15.4253C14.9476 15.5729 15.1481 15.6776 15.3805 15.7373C15.6138 15.7981 15.8144 15.7981 15.9822 15.7384C16.1531 15.6776 16.2821 15.5677 16.3711 15.4075C16.4622 15.2494 16.5062 15.0515 16.5052 14.8159C16.5004 13.6955 16.4953 12.5747 16.4898 11.4536Z" fill="white"/>
                                <path d="M20.2468 13.818C20.2212 13.5719 20.1209 13.3614 19.947 13.1834C19.773 13.0033 19.555 12.8798 19.293 12.8096C19.1057 12.7604 18.945 12.7499 18.8079 12.7813C18.6718 12.8107 18.5653 12.8735 18.4906 12.9698C18.4169 13.0651 18.3811 13.1866 18.3821 13.3342C18.3832 13.4567 18.4088 13.5698 18.4599 13.6724C18.5131 13.7761 18.5807 13.8682 18.6646 13.952C18.7506 14.0337 18.8417 14.107 18.9389 14.173C19.0361 14.2379 19.1292 14.2944 19.2183 14.3436C19.3684 14.4267 19.5181 14.5101 19.6676 14.5939C19.8139 14.6724 19.9633 14.7667 20.1179 14.8766C20.2724 14.9866 20.4157 15.1154 20.5477 15.263C20.6807 15.4106 20.7882 15.5782 20.8701 15.7667C20.954 15.9551 20.997 16.1646 20.999 16.3981C21.0021 16.6912 20.9386 16.9342 20.8056 17.1268C20.6746 17.3195 20.4832 17.4483 20.2294 17.5143C19.9787 17.5813 19.6727 17.5677 19.3135 17.4745C18.9686 17.3855 18.6708 17.2462 18.419 17.0567C18.1662 16.8682 17.9687 16.6431 17.8254 16.3782C17.6821 16.1132 17.6013 15.8211 17.5849 15.5049C17.8162 15.5656 18.0478 15.626 18.2798 15.686C18.2952 15.8776 18.3494 16.0483 18.4446 16.197C18.5408 16.3457 18.6636 16.4703 18.812 16.5687C18.9614 16.6672 19.1251 16.7394 19.3042 16.7865C19.4997 16.8368 19.6727 16.8473 19.8252 16.8179C19.9777 16.7865 20.0984 16.7206 20.1854 16.619C20.2724 16.5153 20.3154 16.3803 20.3144 16.2117C20.3123 16.0577 20.2724 15.9216 20.1936 15.8033C20.1168 15.686 20.0125 15.5771 19.8804 15.4787C19.7505 15.3813 19.6021 15.285 19.4383 15.1928C19.2568 15.0895 19.076 14.9866 18.8959 14.8839C18.5275 14.6735 18.2358 14.4295 18.0188 14.1531C17.8039 13.8777 17.6965 13.5573 17.6944 13.197C17.6924 12.8965 17.762 12.6536 17.9042 12.4683C18.0454 12.284 18.2368 12.1615 18.4804 12.1039C18.7229 12.0431 18.9972 12.0547 19.3032 12.1363C19.6133 12.2191 19.8866 12.3541 20.124 12.5416C20.3635 12.7279 20.5518 12.9478 20.69 13.1991C20.8302 13.4494 20.9038 13.7154 20.912 13.9939C20.6903 13.9353 20.4686 13.8766 20.2468 13.818Z" fill="white"/>
                            </svg>
                            <h3>US/UKスタイル</h3>
                            <p>アメリカ英語／イギリス英語を選択できます。</p>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-4">
                        <div class="list-wrapper-content-2 list-style-cards bt-1">
                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 25" fill="none">
                                <path d="M3.75 4.43945C3.55109 4.43945 3.36032 4.51847 3.21967 4.65912C3.07902 4.79978 3 4.99054 3 5.18945C3 5.38837 3.07902 5.57913 3.21967 5.71978C3.36032 5.86044 3.55109 5.93945 3.75 5.93945H20.25C20.4489 5.93945 20.6397 5.86044 20.7803 5.71978C20.921 5.57913 21 5.38837 21 5.18945C21 4.99054 20.921 4.79978 20.7803 4.65912C20.6397 4.51847 20.4489 4.43945 20.25 4.43945H3.75ZM6.66 18.592L7.314 17.9395H3.75C3.55109 17.9395 3.36032 18.0185 3.21967 18.1591C3.07902 18.2998 3 18.4905 3 18.6895C3 18.8884 3.07902 19.0791 3.21967 19.2198C3.36032 19.3604 3.55109 19.4395 3.75 19.4395H6.126C6.234 19.1305 6.4125 18.8395 6.66 18.592ZM10.4595 14.797C10.1522 14.6813 9.87391 14.4999 9.64408 14.2654C9.41426 14.0309 9.23846 13.749 9.129 13.4395H3.75C3.55109 13.4395 3.36032 13.5185 3.21967 13.6591C3.07902 13.7998 3 13.9905 3 14.1895C3 14.3884 3.07902 14.5791 3.21967 14.7198C3.36032 14.8604 3.55109 14.9395 3.75 14.9395H10.317L10.4595 14.797ZM11.112 10.4395L11.52 10.3885C11.6829 10.3251 11.8185 10.2069 11.9035 10.0542C11.9885 9.90146 12.0175 9.72387 11.9855 9.55206C11.9535 9.38026 11.8625 9.22503 11.7282 9.11318C11.5939 9.00133 11.4248 8.93988 11.25 8.93945H3.75C3.55109 8.93945 3.36032 9.01847 3.21967 9.15912C3.07902 9.29978 3 9.49054 3 9.68945C3 9.88837 3.07902 10.0791 3.21967 10.2198C3.36032 10.3604 3.55109 10.4395 3.75 10.4395H11.112ZM15.75 7.43945C15.933 7.43955 16.1096 7.50655 16.2467 7.62784C16.3837 7.74912 16.4717 7.91632 16.494 8.09795L16.629 9.19895C16.711 9.86289 17.0125 10.4804 17.4857 10.9533C17.9589 11.4262 18.5765 11.7274 19.2405 11.809L20.3415 11.944C20.5238 11.9656 20.6918 12.0534 20.8137 12.1907C20.9356 12.3279 21.0029 12.5051 21.0029 12.6887C21.0029 12.8723 20.9356 13.0495 20.8137 13.1867C20.6918 13.324 20.5238 13.4118 20.3415 13.4335L19.2405 13.5685C18.5766 13.6504 17.9591 13.952 17.4862 14.4251C17.0133 14.8983 16.7121 15.516 16.6305 16.18L16.4955 17.281C16.4738 17.4632 16.386 17.6312 16.2488 17.7531C16.1115 17.875 15.9343 17.9424 15.7507 17.9424C15.5672 17.9424 15.39 17.875 15.2527 17.7531C15.1155 17.6312 15.0277 17.4632 15.006 17.281L14.871 16.18C14.789 15.516 14.4875 14.8985 14.0143 14.4256C13.5411 13.9527 12.9235 13.6515 12.2595 13.57L11.1585 13.435C10.9762 13.4133 10.8082 13.3255 10.6863 13.1882C10.5644 13.051 10.4971 12.8738 10.4971 12.6902C10.4971 12.5066 10.5644 12.3294 10.6863 12.1922C10.8082 12.0549 10.9762 11.9671 11.1585 11.9455L12.2595 11.8105C12.9234 11.7285 13.5409 11.4269 14.0138 10.9538C14.4867 10.4806 14.7879 9.86294 14.8695 9.19895L15.0045 8.09795C15.0269 7.91607 15.115 7.74866 15.2524 7.62734C15.3897 7.50602 15.5667 7.43918 15.75 7.43945ZM15.75 11.1505C15.3705 11.7805 14.841 12.31 14.211 12.6895C14.841 13.069 15.3705 13.5985 15.75 14.2285C16.1295 13.5985 16.659 13.069 17.289 12.6895C16.6581 12.3098 16.1297 11.7814 15.75 11.1505ZM13.281 15.16C13.4216 15.3006 13.5006 15.4913 13.5006 15.6902C13.5006 15.8891 13.4216 16.0798 13.281 16.2205L8.781 20.7145C8.71181 20.7861 8.62906 20.8432 8.53755 20.8825C8.44605 20.9218 8.34764 20.9425 8.24805 20.9434C8.14847 20.9443 8.04971 20.9253 7.95753 20.8876C7.86536 20.8499 7.78162 20.7942 7.7112 20.7237C7.64078 20.6533 7.58509 20.5696 7.54738 20.4774C7.50967 20.3852 7.4907 20.2865 7.49156 20.1869C7.49243 20.0873 7.51312 19.9889 7.55242 19.8974C7.59173 19.8059 7.64887 19.7231 7.7205 19.654L12.2205 15.1585C12.3611 15.0178 12.5519 14.9389 12.7507 14.9389C12.9496 14.9389 13.1404 15.0178 13.281 15.1585V15.16Z" fill="#7A28A0"/>
                            </svg>
                            <h3>語感と文体</h3>
                            <p>学術的な言い回しや文体の文章に校正します。</p>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-4">
                        <div class="list-wrapper-content-2 list-style-cards bt-1">
                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 25" fill="none">
                                <g clip-path="url(#clip0_1083_3335)">
                                  <path d="M14.68 23.25H8C4.35 23.25 2.25 21.15 2.25 17.5V9C2.25 5.35 4.35 3.25 8 3.25H16C19.65 3.25 21.75 5.35 21.75 9V14.13C21.75 14.42 21.58 14.68 21.33 14.81C21.07 14.93 20.76 14.9 20.54 14.72C18.96 13.46 16.53 13.46 14.95 14.75C13.87 15.6 13.26 16.87 13.26 18.26C13.26 19.08 13.48 19.88 13.91 20.57C14.24 21.11 14.65 21.56 15.13 21.9C15.39 22.09 15.51 22.43 15.41 22.74C15.29 23.04 15.01 23.25 14.68 23.25ZM8 4.75C5.14 4.75 3.75 6.14 3.75 9V17.5C3.75 20.36 5.14 21.75 8 21.75H12.89C12.79 21.62 12.7 21.48 12.62 21.34C12.05 20.42 11.75 19.35 11.75 18.25C11.75 16.4 12.57 14.7 14.01 13.57C15.72 12.18 18.25 11.88 20.25 12.8V9C20.25 6.14 18.86 4.75 16 4.75H8Z" fill="#7A28A0"/>
                                  <path d="M13 12.25H7C6.59 12.25 6.25 11.91 6.25 11.5C6.25 11.09 6.59 10.75 7 10.75H13C13.41 10.75 13.75 11.09 13.75 11.5C13.75 11.91 13.41 12.25 13 12.25Z" fill="#7A28A0"/>
                                  <path d="M9.62 17.25H7C6.59 17.25 6.25 16.91 6.25 16.5C6.25 16.09 6.59 15.75 7 15.75H9.62C10.03 15.75 10.37 16.09 10.37 16.5C10.37 16.91 10.04 17.25 9.62 17.25Z" fill="#7A28A0"/>
                                  <path d="M17.75 24.25C16.47 24.25 15.26 23.85 14.24 23.11C13.6 22.65 13.05 22.05 12.62 21.34C12.05 20.42 11.75 19.35 11.75 18.25C11.75 16.4 12.57 14.7 14.01 13.57C16.09 11.88 19.37 11.87 21.47 13.54C22.92 14.68 23.75 16.4 23.75 18.25C23.75 19.35 23.45 20.42 22.88 21.34C22.56 21.89 22.15 22.37 21.68 22.76C20.61 23.72 19.21 24.25 17.75 24.25ZM17.75 13.75C16.73 13.75 15.73 14.1 14.94 14.74C13.86 15.59 13.25 16.86 13.25 18.25C13.25 19.07 13.47 19.87 13.9 20.56C14.23 21.1 14.64 21.55 15.12 21.89C15.89 22.45 16.8 22.75 17.75 22.75C18.86 22.75 19.88 22.36 20.7 21.63C21.06 21.33 21.35 20.98 21.59 20.57C22.02 19.87 22.25 19.07 22.25 18.25C22.25 16.86 21.63 15.5799 20.54 14.7199C19.74 14.0799 18.78 13.75 17.75 13.75Z" fill="#7A28A0"/>
                                  <path d="M17.75 21.5C17.34 21.5 17 21.16 17 20.75C17 19.79 16.21 19 15.25 19C14.84 19 14.5 18.66 14.5 18.25C14.5 17.84 14.84 17.5 15.25 17.5C16.21 17.5 17 16.71 17 15.75C17 15.34 17.34 15 17.75 15C18.16 15 18.5 15.34 18.5 15.75C18.5 16.71 19.29 17.5 20.25 17.5C20.66 17.5 21 17.84 21 18.25C21 18.66 20.66 19 20.25 19C19.29 19 18.5 19.79 18.5 20.75C18.5 21.16 18.16 21.5 17.75 21.5ZM17.32 18.25C17.47 18.38 17.62 18.52 17.75 18.68C17.88 18.53 18.02 18.38 18.18 18.25C18.03 18.12 17.88 17.98 17.75 17.82C17.62 17.98 17.48 18.12 17.32 18.25Z" fill="#7A28A0"/>
                                </g>
                                <defs>
                                  <clipPath id="clip0_1083_3335">
                                    <rect width="24" height="24" fill="white" transform="translate(0 0.5)"/>
                                  </clipPath>
                                </defs>
                            </svg>
                            <h3>高度なスペルチェック</h3>
                            <p>内容・文脈に応じたスペルチェックを行います。</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="signupmobile trinka-banner section-pd-sm">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="trinka-title mb-0 text-center">
                    <h3 class="text-white mb-4">無料アカウントで<br>もっとチェック！</h3>
                    <p class="text-white">Trinkaへのご登録で、毎月5千単語まで英文チェックが無料。文法、スペル、文体の精度向上にご活用ください。</p>
                    <a href="https://cloud.trinka.ai/signup?_rg-JP" target="_blank">今すぐ登録する</a>
                </div>
            </div>
        </div>
    </div>
</div>

<app-other-languages></app-other-languages>

<app-global-leaders></app-global-leaders>

<section class="section-pd">
    <app-power-mode-section></app-power-mode-section>
</section>

<app-suggestion-alerts></app-suggestion-alerts>

<section class="section-pd">
    <app-specialize-writing></app-specialize-writing>
</section>

<app-domain-specific></app-domain-specific>

<div class="section-pd">
    <div class="trinka_container">
        <div class="row">
            <div class="col-sm-12">
                <div class="trinka-title mb-0 text-center">
                    <h2>無料オンライン文法チェッカー</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>AIによる無料文法チェッカーTrinkaは、学術論文・研究論文・テクニカルライティングの英文校正に特化したライティングアシスタントです。複雑な文法ミスの修正だけでなく、語彙レベル、文体レベル、構文レベルなど文章の総合的な改善にご活用いただけます。文法やスペルのミスは即時に検出し、文脈に沿った訂正案が提示されます。</p>
                    <p>Trinkaは、医療・医学、生命科学、物理科学、工学、人文科学、ビジネス、芸術など、1300以上の研究分野の、数多くのすぐれた論文や記事から学習を続けるAIを搭載。ユーザーの研究分野に合わせた英文チェック、提案を行います</p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="trinka-banner section-pd-sm">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-lg-11 col-lg-10">
                <div class="trinka-title mb-0 text-center">
                    <h3 class="text-white mb-4">色々な文献に使える、Trinkaの文法チェッカー</h3>
                    <div class="btn-group justify-content-center mt-4">
                        <a href="https://cloud.trinka.ai/signup?_rg=JP" target="_blank" class="white-btn">
                            <!-- <i class="fa fa-sign-in"></i> -->
                            <span>無料で登録する</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>  
    </div>
</div>

<div class="cloud_key_features section-pd list-wrapper-style-2">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-12">
                <div class="trinka-title mb-0 text-center">
                    <h2>Trinka文法チェッカーの幅広いユーザー層</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>Trinkaは英語のライティングスキル向上を目指すすべての方に最適な文法チェッカーです。研究者などの学術関係者だけでなく、コピーライター、マーケティング担当者、製品開発チーム、ブロガーなど、幅広い方々にご利用いただいています。</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    <h3>研究者・学術関係者</h3>
                    <p>
                        研究論文や学術書籍などの執筆や自己校正の際、学術的な内容を専門的に正しい英語で発信するためにご活用いただけます。
                    </p>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <h3>ビジネスパーソン</h3>
                    <p>
                        レポートやプレゼンテーション、メールの文面など、様々な英語のビジネス文書の校正にも役立ちます。
                    </p>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <h3>学生</h3>
                    <p>
                        英語で提出するレポートや小論文、学位論文などの学問的な英文ライティングに、まだ慣れていない人にもおすすめです。                       
                    </p>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <h3>英文ライター</h3>
                    <p>
                        自己PR、カバーレター、SNSへの投稿など、英語の文書やメッセージを作成する必要がある、すべての人にお使いいただけます。
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="use_trinka_other_app section-pd-sm">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="trinka-title mb-0 text-center">
                    <h3 class="text-white">プラグイン・アドインで、いつでもどこでも良質なライティングを</h3>
                </div>
                <div class="use_trinka_content">
                    <div class="others_app_name">
                        <ul>
                            <li>
                                <a [routerLink]="['/trinkacloud']">
                                    <div class="app_name_content" >
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/Other_apps_TrinkaCloud.svg" width="45" height="45" loading="lazy" decoding="async"  alt="無料の文法チェックツール">
                                        <h3>Cloud</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a [routerLink]="['/wordplugin']">
                                    <div class="app_name_content">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/wordAdd-in1.svg" width="45" height="45" loading="lazy" decoding="async"  alt="単語 - 文法チェッカー">
                                        <h3>MS Word</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a [routerLink]="['/browser-plugin']">
                                    <div class="app_name_content">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/NewChromeIcon.svg" width="45" height="45" loading="lazy" decoding="async"  alt="chrome - 文法チェッカー">
                                        <h3>Chrome</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a [routerLink]="['/browser-plugin']">
                                    <div class="app_name_content" >
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/NewFirefoxIcon.svg" width="45" height="45" loading="lazy" decoding="async"  alt="Firefox - 文法チェッカー">
                                        <h3>Firefox</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a [routerLink]="['/browser-plugin']">
                                    <div class="app_name_content">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/EdgeWhite_BGAndOutline.svg" width="45" height="45" loading="lazy" decoding="async"  alt="edge - 文法チェッカー">
                                        <h3>Edge</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a [routerLink]="['/browser-plugin']">
                                    <div class="app_name_content">
                                        <span class="safariComingSoonTag">近日公開</span>
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/safari_logo.png" width="45" height="45" loading="lazy" decoding="async"  alt="safari - 文法チェッカー">
                                        <h3>Safari</h3>
                                    </div>
                                </a>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<section class="section-pd list-wrapper-style-2">
    <div class="trinka_container">
        <div class="row align-items-center flex-row-reverse">
            <div class="col-md-6">
                <div class="list-wrapper-content-2">
                    <h3>Trinkaで、文章執筆をより効果的に</h3>
                    <p>Trinkaは、トーン、文構造、単語の選択、読みやすさなど、総合的に文章をチェックし改善する文章校正ツールです。文単位での改善、表記や句読点の修正など、包括的な校正でワークフローの効率化が可能になります。</p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="list-wrapper-image">
                    <picture>
                        <source srcset="../../../assets/images/WritingMoreEffective.webp" type="image/webp">
                        <img src="../../../assets/images/WritingMoreEffective.png" class="grammar-check-img" loading="lazy" decoding="async" alt="文法 チェック">
                    </picture>
                    <!-- <img src="../../../assets/images/WritingMoreEffective.png" loading="lazy" decoding="async"  alt="文法 チェック"> -->
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd list-wrapper-style-2 pt-0">
    <div class="trinka_container">
        <div class="row align-items-center">
            <div class="col-md-6">
                <div class="list-wrapper-content-2 pr-80">
                    <h3>英語学習にも効果的な文法チェッカー
                    </h3>
                    <p>Trinkaが提示する修正の提案は、英語学習の教材にもなります。また、文書全体の言語品質のスコアを見ることもできます。</p>
                    <p>効果的で質の高いライティング技術を身に付けたいという学生の皆様にもご活用いただけます。</p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="list-wrapper-image features-img">
                    <picture>
                        <source srcset="../../../assets/images/LearnGrammarwithTrinka.webp" type="image/webp">
                        <img src="../../../assets/images/LearnGrammarwithTrinka.png" class="grammar-check-img" loading="lazy" decoding="async" alt="文法 チェック">
                    </picture>
                    <!-- <img src="../../../assets/images/LearnGrammarwithTrinka.png" loading="lazy" decoding="async"  alt="文法 チェック"> -->
                </div>
            </div>
        </div>
    </div>
</section>

<div class="testimonial-section text-center section-pd">
    <app-testimonial></app-testimonial>
</div>

<div class="trinka-banner section-pd-sm">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-8">
                <div class="trinka-title mb-0 text-center">
                    <h3 class="text-white mb-4">無料のベーシックプランから、ぜひお試しください</h3>
                    <div class="btn-group justify-content-center">
                        <a href="https://cloud.trinka.ai/signup?_rg=JP" target="_blank" class="white-btn" id="grammerSignUpButton">
                            <!-- <i class="fa fa-sign-in"></i> -->
                            <span>無料登録する</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>  
    </div>
</div>  

<div class="faqQuestionAnwser section-pd" #target>
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="trinka-title text-center">
                    <h2>Trinka文法チェッカーに関するよくあるご質問
                    </h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="faqQuestionsList">
            <div class="accordion" id="faq">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionGCOne">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionGCOneContent" aria-expanded="true" aria-controls="QuestionGCOneContent">
                                        <span class="OpenSansFonts">Trinka</span>と他のオンライン文法チェッカーとの違いは何ですか？
                                    </a>
                                </div>
                            
                                <div id="QuestionGCOneContent" class="collapse" aria-labelledby="QuestionGCOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>
                                            <span class="OpenSansFonts">Trinka</span>の開発チームは、5つの学術系ドメインから集めた5,778語の英文の校正を、他の無料文法チェッカーによる校正と比較検証しました。その結果、訂正箇所の正確さ、スタイルガイドへの合致、簡潔さ、文脈に応じたスペルチェックなどの項目において、Trinkaが優れた性能を示しました。結果についての解説資料は
                                            <a href="/trinka-vs-grammarly-vs-language-tool">こちら</a>からご覧ください。
                                        </p>
                                    </div>
                                </div>
                            </div>
                            
    
                            
                            <div class="card">
                                <div class="card-header" id="QuestionGCTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCTwoContent" aria-expanded="true"
                                        aria-controls="QuestionGCTwoContent"><span class="OpenSansFonts">Trinka</span>の有料プランは、他の無料文法チェッカーとはどう違いますか？</a>
                                </div>
    
                                <div id="QuestionGCTwoContent" class="collapse"
                                    aria-labelledby="QuestionGCTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p><span class="OpenSansFonts">Trinka</span>は一般的な文法チェッカーとは異なり、学術論文やテクニカルライティングに特化した英文校正ツールです。無料のベーシックプランでも、他社の有料プランにはない多くの機能が含まれていますが、プレミアムプランでは、リーズナブルな価格で、ライティングのあらゆるニーズをカバーする機能を無制限でご利用いただけます。</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionGCThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCThreeContent" aria-expanded="true"
                                        aria-controls="QuestionGCThreeContent"><span class="OpenSansFonts">Trinka</span>を使えるプラットフォーム、アプリを教えてください</a>
                                </div>
    
                                <div id="QuestionGCThreeContent" class="collapse"
                                    aria-labelledby="QuestionGCThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p><span class="OpenSansFonts">Trinka</span>はどのブラウザでもご利用いただけます。また、Chrome、Firefox、Edgeなどのブラウザのプラグインも提供しており、ウェブサイト上の英文入力もリアルタイムで校正できます。プレミアムプランでは、MS Wordのアドインもご利用いただけます。</p>
                                    </div>
                                </div>
                            </div>
    
                            <div class="card">
                                <div class="card-header" id="QuestionGCFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCFourContent" aria-expanded="true"
                                        aria-controls="QuestionGCFourContent">自社ソフトウェアに<span class="OpenSansFonts">Trinka</span>を組み込むことはできますか？</a>
                                </div>
    
                                <div id="QuestionGCFourContent" class="collapse"
                                    aria-labelledby="QuestionGCFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p><span class="OpenSansFonts">Trinka</span>では、統合用の各種オプションを提供する<span class="OpenSansFonts">Trinka Enterprise</span> をご用意しています。ウェブサイトに文法チェックを統合できるJavaScript(JS)のコード、Trinka JSや、既存の製品やワークフローにTrinkaを統合する、Trinka APIなど、お客様のニーズに合わせてご提供いたします。お気軽に<a href="mailto:support@trinka.ai" class="text-link"><span class="OpenSansFonts">support@trinka.ai</span></a>までお問い合わせください。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCFive">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCFiveContent" aria-expanded="true"
                                        aria-controls="QuestionGCFiveContent">どうすれば、英文をオンラインで無料チェックできますか？</a>
                                </div>
    
                                <div id="QuestionGCFiveContent" class="collapse"
                                    aria-labelledby="QuestionGCFive" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka（トリンカ）を使えば、オンラインで無料英文チェックができます。AIを搭載した先進的なツールで分かりやすい英語に仕上げられます。細かい句読点の間違いやタイプミスから、微妙な文法ミスや言い回しの問題まで、英語で書いた文章をチェックできます。<a [routerLink]="['/browser-plugin']" class="text-link">ブラウザプラグインを</a>使えばオンラインでのライティングも、Wordプラグインを使えばMicrosft Wordでのライティングもチェックできます。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCSix">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCSixContent" aria-expanded="true"
                                        aria-controls="QuestionGCSixContent">英語の文章が文法的に正しいかをチェックするにはどうすればよいですか？</a>
                                </div>
    
                                <div id="QuestionGCSixContent" class="collapse"
                                    aria-labelledby="QuestionGCSix" data-parent="#faq">
                                    <div class="card-body">
                                        <p>In order to check the grammatical correctness of a sentence, simply paste it in Trinka's spelling and <strong>grammar checker</strong>. Trinka will thoroughly check the sentence for punctuation, grammar, and vocabulary mistakes.</p>
                                        <p>Trinka（トリンカ）<b>のスペル・文法チェッカーに文章を貼り付けるだけで、かんたんに文法の正しさをチェックできます。</b>Trinkaは、句読点、文法、語彙の間違いがないか徹底的にチェックします。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCSeven">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCSevenContent" aria-expanded="true"
                                        aria-controls="QuestionGCSevenContent">Twitterに入力する英語のスペルをチェックできますか？</a>
                                </div>
    
                                <div id="QuestionGCSevenContent" class="collapse"
                                    aria-labelledby="QuestionGCSeven" data-parent="#faq">
                                    <div class="card-body">
                                        <p>お使いのブラウザにTrinka<a [routerLink]="['/browser-plugin']" class="text-link">（トリンカ）</a>のブラウザプラグインをインストールすれば、英文のツイートをTrinkaでリアルタイムにチェックできます。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCEight">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCEightContent" aria-expanded="true"
                                        aria-controls="QuestionGCEightContent">オンラインでWordファイルの文法ミスをチェックできますか？</a>
                                </div>
    
                                <div id="QuestionGCEightContent" class="collapse"
                                    aria-labelledby="QuestionGCEight" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka（トリンカ）の<a [routerLink]="['/wordplugin']" class="text-link">Wordプラグイ</a>ンをインストールすれば、リアルタイムでの英文校正が可能です。さらに、ファイル自動校正機能では、変更履歴付きの自動校正済みWordファイルをダウンロードして質の高い文書を迅速に作成いただけます。Wordプラグインの便利でパワフルな機能は、プレミアムプランを購入いただいたお客様にご利用いただけます。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCNine">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCNineContent" aria-expanded="true"
                                        aria-controls="QuestionGCNineContent">Trinkaの文法チェッカーはどのように機能するのでしょうか？</a>
                                </div>
    
                                <div id="QuestionGCNineContent" class="collapse"
                                    aria-labelledby="QuestionGCNine" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka（トリンカ）の文法チェッカーは、様々な分野の何百万もの<b>英語</b>原稿を読み込んで学習を重ねた高度な自然言語処理（NLP）アルゴリズムを使用しています。また、様々な文法ルールを、継続的なテストと更新を経て高い精度で学習することで、質の高い英文校正を実現しています。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCTen">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCTenContent" aria-expanded="true"
                                        aria-controls="QuestionGCTenContent">Chromeで英語の文法をチェックするにはどうすればよいですか？</a>
                                </div>
    
                                <div id="QuestionGCTenContent" class="collapse"
                                    aria-labelledby="QuestionGCTen" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka（トリンカ）のブラウザプラグインをインストール<a [routerLink]="['/browser-plugin']" class="text-link">すれば</a>、Chromeを含むお使いのブラウザで自動的に英文をチェックできるようになります。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCeleven">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCelevenContent" aria-expanded="true"
                                        aria-controls="QuestionGCelevenContent">Trinkaの文法チェッカーはどのくらい正確ですか？ </a>
                                </div>
    
                                <div id="QuestionGCelevenContent" class="collapse"
                                    aria-labelledby="QuestionGCeleven" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka（トリンカ）は、英語論文・テクニカルライティング用に開発された、アカデミックな文章、技術関連の文章の校正に最適な無料文法チェッカーです。当社調べでは、<b>通常90%以上の適合率と80%以上の再現率を</b>達成しています。</p>
                                    </div>
                                </div>
                            </div>
                            

                            <div class="card">
                                <div class="card-header" id="QuestionGCTwelve">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCTwelveContent" aria-expanded="true"
                                        aria-controls="QuestionGCTwelveContent">TrinkaでWord文書の英文チェックを行えますか？ </a>
                                </div>
    
                                <div id="QuestionGCTwelveContent" class="collapse"
                                    aria-labelledby="QuestionGCTwelve" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka（トリンカ）<a [routerLink]="['/wordplugin']" class="text-link">のWordプラ</a>グインをインストールすれば、リアルタイムでの英文校正が可能です。さらに、ファイル自動校正機能では、変更履歴付きの自動校正済みWordファイルをダウンロードして質の高い英文を迅速に作成いただけます。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCThirteen">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCThirteenContent" aria-expanded="true"
                                        aria-controls="QuestionGCThirteenContent">Trinkaの無料文法チェッカーでは文構造の修正もできますか？</a>
                                </div>
    
                                <div id="QuestionGCThirteenContent" class="collapse"
                                    aria-labelledby="QuestionGCThirteen" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka’s free <b>grammar checker</b> goes beyond grammar checks and enhances your writing for sentence structure, style, tone, and much more.</p>
                                        <p>Trinka（トリンカ）では、文法ミスの修正だけでなく、<b>英語</b>の文構造やスタイル、トーンの改定など、文章を包括的に改善します。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCFouteen">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCFouteenContent" aria-expanded="true"
                                        aria-controls="QuestionGCFouteenContent">Trinkaのスペルチェック機能や文法チェック機能は無料で使えますか？ </a>
                                </div>
    
                                <div id="QuestionGCFouteenContent" class="collapse"
                                    aria-labelledby="QuestionGCFouteen" data-parent="#faq">
                                    <div class="card-body">
                                        <p>この<b>ページ</b>では300単語が上限ですが、ベーシックプランにご登録いただくと1か月5000単語まで無料でお使いいただけます。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCFivteen">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCFivteenContent" aria-expanded="true"
                                        aria-controls="QuestionGCFivteenContent">Trinkaを使って英語原稿の文法を改善できますか？</a>
                                </div>
    
                                <div id="QuestionGCFivteenContent" class="collapse"
                                    aria-labelledby="QuestionGCFivteen" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka（トリンカ）は文法やスペルチェックにとどまらず、英文の言語品質を総合的に向上させることができます。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="faqContainer">

                            <div class="card">
                                <div class="card-header" id="QuestionGCSixteen">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCSixteenContent" aria-expanded="true"
                                        aria-controls="QuestionGCSixteenContent">Trinkaは論文の英文チェックに使えますか？ </a>
                                </div>
    
                                <div id="QuestionGCSixteenContent" class="collapse"
                                    aria-labelledby="QuestionGCSixteen" data-parent="#faq">
                                    <div class="card-body">
                                        <p>英語論文やテクニカルライティング、フォーマルな文書のために開発されたTrinka<b>（トリンカ）</b>は、論文原稿に最適なオンライン文法チェッカーです。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCSeventeen">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCSeventeenContent" aria-expanded="true"
                                        aria-controls="QuestionGCSeventeenContent">Trinkaは用語や表記の不統一を検出できますか？</a>
                                </div>
    
                                <div id="QuestionGCSeventeenContent" class="collapse"
                                    aria-labelledby="QuestionGCSeventeen" data-parent="#faq">
                                    <div class="card-body">
                                       <p>Trinka<b>（トリンカ）</b>には、用語統一という機能があり、ワンクリックで5つのタイプの用語・<a [routerLink]="['/features/consistency-check']" class="text-link">表記の不統</a>一を修正できます。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCEighteen">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCEighteenContent" aria-expanded="true"
                                        aria-controls="QuestionGCEighteenContent">Trinkaの文法チェッカーでMS Wordの文書をチェックできますか？</a>
                                </div>
    
                                <div id="QuestionGCEighteenContent" class="collapse"
                                    aria-labelledby="QuestionGCEighteen" data-parent="#faq">
                                    <div class="card-body">
                                       <p>Trinka<b>（トリンカ）</b><a [routerLink]="['/wordplugin']" class="text-link">のWordプラグ</a>インをインストールすれば、リアルタイムでの英文校正が可能です。さらに、ファイル自動校正機能では、変更履歴付きの自動校正済みWordファイルをダウンロードして質の高い文書を迅速に作成いただけます。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCNinteen">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCNinteenContent" aria-expanded="true"
                                        aria-controls="QuestionGCNinteenContent">Trinkaは、オフラインで利用できますか？ </a>
                                </div>
    
                                <div id="QuestionGCNinteenContent" class="collapse"
                                    aria-labelledby="QuestionGCNinteen" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka（トリンカ）はリアルタイムで修正提案を行うため、ご利用にはインターネット接続が必要です。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGC20">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGC20Content" aria-expanded="true"
                                        aria-controls="QuestionGC20Content">自分の書いた英文の文法が正しいか、どこでチェックできますか？</a>
                                </div>
    
                                <div id="QuestionGC20Content" class="collapse"
                                    aria-labelledby="QuestionGC20" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka（トリンカ）をお使いいただくと、<b>英語</b>文章を即時に自動校正できます。下線を引かれた部分の提案をクリックすることでスペルミスや文法の誤りを修正したり、スタイル提案を受け入れたりできます。 </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGC21">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGC21Content" aria-expanded="true"
                                        aria-controls="QuestionGC21Content">無料文法チェックはどこで行えますか？ </a>
                                </div>
    
                                <div id="QuestionGC21Content" class="collapse"
                                    aria-labelledby="QuestionGC21" data-parent="#faq">
                                    <div class="card-body">
                                       <p>Trinka <b>（トリンカ）</b>のベーシックプランでブラウザプラグインを使えば、インターネット上のどのようなサイト上でも無料で文法チェッ<a [routerLink]="['/browser-plugin']" class="text-link">クをお使いいた</a>だけます。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGC22">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGC22Content" aria-expanded="true"
                                        aria-controls="QuestionGC22Content">Trinkaでは、文法修正の意図を説明してくれますか？ </a>
                                </div>
    
                                <div id="QuestionGC22Content" class="collapse"
                                    aria-labelledby="QuestionGC22" data-parent="#faq">
                                    <div class="card-body">
                                        <p><B>はい。</B>Trinka（トリンカ）をお使いいただくと、ご自身の英文のどこが間違っているをご理解いただいた上で適切な変更を加えられるよう、説明付きの修正案が示されます。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGC23">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGC23Content" aria-expanded="true"
                                        aria-controls="QuestionGC23Content">文法チェッカーTrinkaを使えば、人の手による英文校正は必要なくなりますか？ </a>
                                </div>
    
                                <div id="QuestionGC23Content" class="collapse"
                                    aria-labelledby="QuestionGC23" data-parent="#faq">
                                    <div class="card-body">
                                        <p>The quality of the original writing will determine this. A proofreader would be beneficial if you do not speak English and make several complex errors pertaining to logical construction in English. Trinka can fix thousands of grammatical mistakes and complex writing problems. However, AI is limited. If the construction is not logical, it cannot decipher your intended meaning. For those who possess sufficient knowledge of the English language to construct logically correct sentences, Trinka <b>grammar checker</b> can take care of tone, word choice, grammatical constructions, spelling, and a whole lot more.
                                        </p>
                                        <p>元の<b>英語</b>文章の質によります。<b>英語</b>をほとんど使われない方の原稿で、論理構造に関わるミスが多いものについては、人の手による英文校正を行うのが望ましいでしょう。Trinka（トリンカ）は<b>3000種以上</b>にも及ぶ文法ミスや複雑な文章の問題を修正することができますが、<b>AIには</b>まだ限界があります。論理的に構成されていない英文の場合、著者の意図を読み解くことができないのです。論理的に校正された英文の場合、Trinkaはトーンや単語の選択、構文、スペル、その他多くのポイントで有効な修正案を提案できます。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGC24">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGC24Content" aria-expanded="true"
                                        aria-controls="QuestionGC24Content">Trinkaの文法チェッカーで、句読点のチェックはできますか？</a>
                                </div>
    
                                <div id="QuestionGC24Content" class="collapse"
                                    aria-labelledby="QuestionGC24" data-parent="#faq">
                                    <div class="card-body">
                                        <p>はい。Trinka（トリンカ）は、句読点の修正案も提案します。これにより質の高い英文への改善が可能です。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGC25">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGC25Content" aria-expanded="true"
                                        aria-controls="QuestionGC25Content">プレミアムプランに学生割引はありますか？</a>
                                </div>
    
                                <div id="QuestionGC25Content" class="collapse"
                                    aria-labelledby="QuestionGC25" data-parent="#faq">
                                    <div class="card-body">
                                        <p>学生の皆さまは、プレミアムプランを20％割引でご利用いただけます。割引料金でのご利用をご希望の方は<a href="mailto:support@trinka.ai" class="text-link">support@trinka.ai</a> までご連絡ください。</p>
                                    </div>
                                </div>
                            </div>

                            <!-- <div class="card">
                                <div class="card-header" id="QuestionGC26">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGC26Content" aria-expanded="true"
                                        aria-controls="QuestionGC26Content">Trinkaは日本語以外の言語に対応していますか？</a>
                                </div>
    
                                <div id="QuestionGC26Content" class="collapse"
                                    aria-labelledby="QuestionGC26" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinkaは英語、日本語、スペイン語、ドイツ語に対応しています。 </p>
                                    </div>
                                </div>
                            </div> -->

                            <div class="card">
                                <div class="card-header" id="QuestionGC27">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGC27Content" aria-expanded="true"
                                        aria-controls="QuestionGC27Content">Trinkaはどのウェブサイトで使えますか？</a>
                                </div>
    
                                <div id="QuestionGC27Content" class="collapse"
                                    aria-labelledby="QuestionGC27" data-parent="#faq">
                                    <div class="card-body">
                                        <p>お使いのブラウザにTrinka（トリンカ）のブラウザプラグインをインストールすれば、あらゆるサイト上でTrinkaの文法チェッカー<a [routerLink]="['/browser-plugin']" class="text-link">をご利用い</a>ただけます。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGC28">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGC28Content" aria-expanded="true"
                                        aria-controls="QuestionGC28Content">Trinkaはどのようなアプリケーションに対応していますか？ </a>
                                </div>
    
                                <div id="QuestionGC28Content" class="collapse"
                                    aria-labelledby="QuestionGC28" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka（トリンカ）のベーシックプランに登録し、ブラウザプラグインをダウンロードすれば、あらゆるウェブサイト上で英文チェックを行えます。<a [routerLink]="['/browser-plugin']" class="text-link">プレミアムプランに登録すると</a>、ブラウザプラグインに加えてMS Wordのプラグインも使え、<b>英語</b>文書を作成中にリアルタイムで英<a [routerLink]="['/wordplugin']" class="text-link">文チェック</a>を行えます。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGC29">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGC29Content" aria-expanded="true"
                                        aria-controls="QuestionGC29Content">Trinkaはどのような英語の間違いを訂正できますか？</a>
                                </div>
    
                                <div id="QuestionGC29Content" class="collapse"
                                    aria-labelledby="QuestionGC29" data-parent="#faq">
                                    <div class="card-body">
                                        <p>スペルや文法以外にも、Trinka<b>（トリンカ）</b>の文法チェッカーは句読点や文構造、トーンなどを修正し、英文の質を改善します。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGC30">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGC30Content" aria-expanded="true"
                                        aria-controls="QuestionGC30Content">Trinkaは、博士論文や修士論文などの学位論文の文法チェックにも使えますか？ </a>
                                </div>
    
                                <div id="QuestionGC30Content" class="collapse"
                                    aria-labelledby="QuestionGC30" data-parent="#faq">
                                    <div class="card-body">
                                        <p>はい。Trinka（トリンカ）は、学術的な文書やテクニカルライティングに特化した英文チェッカーです。学位論文、研究論文、レポート、エッセイなど、フォーマルな文書の英文チェッ<b>クに最適です</b>。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGC31">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGC31Content" aria-expanded="true"
                                        aria-controls="QuestionGC31Content">Trinkaの文法チェッカーは多言語の校正に対応していますか？</a>
                                </div>
    
                                <div id="QuestionGC31Content" class="collapse"
                                    aria-labelledby="QuestionGC31" data-parent="#faq">
                                    <div class="card-body">
                                        <p>現在、Trinka AIでは英語とスペイン語の校正を行えます。そして今後のアップデートで、随時、対応言語を増やしていく予定です。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>